import {
  getAllowedHosts,
  Provider,
  tokenStorage
} from '@uppy/companion-client';
import { UIPlugin } from '@uppy/core';
import { ProviderViews } from '@uppy/provider-views';
import { h } from 'preact';

const icon = () =>
  h(
    'svg',
    {
      'aria-hidden': 'true',
      focusable: 'false',
      width: '32',
      height: '32',
      viewBox: '0 0 32 32'
    },
    h(
      'g',
      { fill: 'none', fillRule: 'nonzero' },
      h('path', {
        d: 'M13.5 11.2a5.8 5.8 0 0 1 5.2 3.2l.3-.1a4.5 4.5 0 0 1 4.5 4.5 4.5 4.5 0 0 1-4.5 4.5H9a3.8 3.8 0 0 1-3.8-3.8A3.8 3.8 0 0 1 9 15.7l.2.001A5.8 5.8 0 0 1 13.5 11.2z',
        fill: '#036C70'
      }),
      h('path', {
        d: 'M19 14.4a4.5 4.5 0 0 1 4.5 4.5 4.5 4.5 0 0 1-4.5 4.5h-4.5L18 18l1-3.6z',
        fill: '#1A9BA1'
      }),
      h('path', {
        d: 'M9.2 15.7A3.8 3.8 0 0 0 5.2 19.5a3.8 3.8 0 0 0 3.8 3.8h5.5l-2-3.5-2.3-4.1z',
        fill: '#03787C'
      })
    )
  );

export default class SharePoint extends UIPlugin<any, any, any> {
  static VERSION = '1.0.0';

  icon: () => any;

  provider: any;

  view: any;

  storage: any;

  files: any[];

  rootFolderId: string | null = null;

  constructor(uppy: any, opts: any) {
    super(uppy, opts);
    this.type = 'acquirer';
    this.files = [];
    this.storage = this.opts.storage || tokenStorage;
    this.id = this.opts.id || 'SharePoint';
    this.icon = icon;

    (this.opts as any).companionAllowedHosts = getAllowedHosts(
      this.opts.companionAllowedHosts,
      this.opts.companionUrl
    );
    this.provider = new Provider(uppy, {
      companionUrl: this.opts.companionUrl,
      companionHeaders: this.opts.companionHeaders,
      companionKeysParams: this.opts.companionKeysParams,
      companionCookiesRule: this.opts.companionCookiesRule,
      provider: 'sharepoint',
      pluginId: this.id,
      supportsRefreshToken: true
    });

    this.title = 'SharePoint';
    this.render = this.render.bind(this);
  }

  install() {
    this.view = new ProviderViews(this as any, {
      provider: this.provider,
      loadAllFiles: true,
      virtualList: true
    });
    const { target } = this.opts;
    if (target) {
      this.mount(target, this);
    }
  }

  uninstall() {
    this.view.tearDown();
    this.unmount();
  }

  render(state: any) {
    return this.view.render(state);
  }
}
